import { render } from "./HeroBanner.vue?vue&type=template&id=50b188c4"
import script from "./HeroBanner.vue?vue&type=script&lang=js"
export * from "./HeroBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__